<template>

  <div class="main-content container-fluid">
    <div class="row">
      <div class="col-xs-12">
        <Panel class="panel panel-default panel-border-color panel-border-color-primary">
          <PanelBody>
            <div class="processing">
              <div class="icon">
                <img src="/static/img/logo-icon.png" />
              </div>
              <div class="text">
                <h2>Processing{{message}}</h2>
                <p>
                  Your file is being processed. Please <strong>do not refresh this page</strong>.<br />
                  You will be redirected shortly to create your lecture notes.
                </p>
              </div>
            </div>
          </PanelBody>
        </Panel>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'underscore'
  import { mapState, mapGetters, mapActions } from 'vuex'
  import Chapter from '../../resources/chapter'

  export default {
    props: {
      chapter: Object,
    },

    components: {
    },

    created() {
      this.getChapters();

      const id = this.$route.params.id;
      if (id && !isNaN(id)) {
        this.checkStatus(id);
      }
    },

    methods: {
      ...mapActions({
        getChapters: 'getChapters',
      }),
      checkStatus(id) {
        if (this.process) {
          if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
          }

          this.$http.get('upload/' + id, {
            emulateJSON: true,
            timeout: 99999999,
          }).then((res) => {
            console.log(res)

            if (res.body.status.toLowerCase() === 'in progress') {
              this.updateProcessMessage();
              this.timer = setTimeout(function () { this.checkStatus(id) }.bind(this), 2000);
            } else if (res.body.status.toLowerCase() === 'error') {
              this.processFailed(res.body.error);
            } else if (res.body.status.toLowerCase() === 'complete' && !isNaN(res.body.lecture_note_id)) {
              this.$router.push({ name: 'lecture-note-editor', params: { id: res.body.lecture_note_id }, query: { help: this.chapters.length <= 0 } });
              Toast.success('Lecture note imported')
            } else {
              this.processFailed('Failed to import lecture note. Please try again.');
            }
          }, (res) => {
            // Show error
            let errMessage = 'Failed to import lecture note. Please try again.';
            if (res.body && _.isArray(res.body.errors)) errMessage = `Error: ${res.body.errors[0]}`;
            this.processFailed(errMessage);
          })
        }
      },

      updateProcessMessage() {
        this.attempt += 1;
        this.message += '.';
        if (this.message.length > 3) {
          this.message = '';
        }
      },

      processFailed(message) {
        Toast.error(message)
        this.$router.push({ name: 'importer' });
      }
    },

    data() {
      return {
        attempt: 1,
        message: '',
        timer: null,
        process: true
      }
    },

    computed: {
      ...mapGetters({
        chapters: 'allChapters',
      }),
    },

    beforeDestroy: function () {
      this.process = false;
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .processing {text-align:center;padding:50px 0px;}
  .processing h2 {margin-top:50px;}
  .processing p {margin-bottom:0px;}
  .processing .icon img { animation: lds-hourglass 1.8s infinite; font-size: 50px; color: #FFFFFF; }

  @keyframes lds-hourglass {
    0% { transform: rotate(0); animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19); }
    50% { transform: rotate(900deg); animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }
    100% { transform: rotate(1800deg); }
  }
</style>



// WEBPACK FOOTER //
// FileProcessing.vue?3bbf70ab